/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Text,
  Divider,
  Icon,
  SimpleGrid,
  Image,
  IconButton,
} from '@chakra-ui/react';
import { RefundDTO } from '../../../../modules/refunds/types';
import { ArrowBackIcon, ViewIcon } from '@chakra-ui/icons';

// Пропсы для компонента с использованием нового интерфейса
interface ReturnDetailPageProps {
  returnData: RefundDTO;
  onBackClick?: VoidFunction;
}

export const ReturnDetailPage: React.FC<ReturnDetailPageProps> = ({ returnData, onBackClick }) => {
  return (
    <Flex flex="1" direction="column" p={8}>
      <Box maxWidth="700px">
        {/* Заголовок с кнопкой "Назад" */}
        <Flex align="center" mb={4}>
          {onBackClick && (
            <IconButton
              icon={<ArrowBackIcon />}
              aria-label="Назад"
              onClick={onBackClick}
              variant="ghost"
              mr={2}
              fontSize="1.5rem"
            />
          )}
          <Heading size="lg">Заявка на возврат №{returnData.number}</Heading>
        </Flex>

        {/* Дата */}
        <Text fontSize="sm" color="gray.500" mb={2}>
          {new Date(returnData.created_at).toLocaleDateString()} &nbsp;&bull;&nbsp;{' '}
          {new Date(returnData.created_at).toLocaleTimeString()}
        </Text>

        {/* Информация о клиенте */}
        <Box mb={6}>
          <Heading size="md" mb={2}>
            Клиент
          </Heading>
          <Text fontWeight="bold">ID пользователя: {returnData.user_id}</Text>
        </Box>

        {/* Информация о товаре */}
        <Box mb={6}>
          <Heading size="md" mb={2}>
            {returnData.order_item.good_name}
          </Heading>
          <Text color="gray.600" mb={2}>
            {returnData.order_item.good_description}
          </Text>
          <Text fontWeight="bold">
            {returnData.order_item.price} &nbsp;&bull;&nbsp; {returnData.order_item.amount} шт.
          </Text>
        </Box>

        <Divider my={4} />

        {/* Причина возврата */}
        <Box mb={6}>
          <Heading size="md" mb={2}>
            Причина возврата
          </Heading>
          <Text color="gray.600">{returnData.reason}</Text>
        </Box>

        {/* Фотографии */}
        <Heading size="md" mb={4}>
          Приложенные фотографии
        </Heading>
        <SimpleGrid columns={4} spacing={4}>
          {returnData.attachments && returnData.attachments.length > 0
            ? returnData.attachments.map((attachment, index) => (
                <Box
                  key={attachment.pk}
                  border="1px solid"
                  borderColor="gray.300"
                  borderRadius="md"
                  p={2}
                  textAlign="center"
                >
                  <Image
                    src={attachment.file}
                    alt={`attachment-${index}`}
                    boxSize="100px"
                    objectFit="cover"
                    borderRadius="md"
                    fallback={<Icon as={ViewIcon} boxSize={8} color="gray.500" />}
                  />
                </Box>
              ))
            : // Если изображений нет, выводим пустые иконки
              Array.from({ length: 4 }).map((_, index) => (
                <Box
                  key={index}
                  border="1px solid"
                  borderColor="gray.300"
                  borderRadius="md"
                  p={2}
                  textAlign="center"
                >
                  <Icon as={ViewIcon} boxSize={8} color="gray.500" />
                </Box>
              ))}
        </SimpleGrid>
      </Box>
    </Flex>
  );
};
